<template>
   <dates 
      v-if="selectedActivity"
      :selectedActivity="selectedActivity"
      :locale="locale"
      :config="config"
      :content="content"
      :onClose="() => {selectedActivity=null}"
   />
   <v-layout wrap
      v-else
      justify-center
   >
      <v-flex xs12
         v-for="item of activities"
         :key="item.ID"
         style="padding:10px"
      >
      <v-card style="padding:10px"
         @click="selectedActivity=item"
      >
         {{getTranslation(item.Name, locale)}}
      </v-card>
      </v-flex>
   </v-layout>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'
import utils from '@/services/utils'
import Dates from './Dates'
export default {
   components: {
      Dates,
   },
   props: {
      locale: {
         type: String,
         required: true,
      },
      content: {
         type: Object,
         required: true,
      },
      config: {
         type: Object,
         required: true,
      },
   },
   data: () => ({
      loading: false,
      activities: null,
      selectedActivity: null,
   }),
   computed: {
      ...mapState('app', ['dtouchWorkspace']),
   },
   mounted () {
      this.getActivities()
   },
   methods: {
      parseJSON (v) {
         return typeof v === 'string' ? JSON.parse(v) : v
      },
      getTranslation (v, locale) {
         return utils.getTranslation(v, locale)
      },
      getActivities () {
         // get all activities
         const url = `${window.location.protocol}//${process.env.VUE_APP_API_URL_DTOUCH}/v1/public/cm/${this.dtouchWorkspace}/activities`
         axios.get(url)
            .then((response) => {
               this.activities = response.data.map(item => {
                  return {
                     ID: item.ID,
                     Name: this.parseJSON(item.Name),
                     Image: item.Image,
                     Source: item.Source,
                     TimeLimit: item.TimeLimit
                  }
               })
            })
            .catch((error) => {
               console.log(error)
            })
            .then(() => {
               this.loading = false
            })
      },
      /*
      getActivities () {
         // get all activities
         const url = `${window.location.protocol}//${process.env.VUE_APP_API_URL_DTOUCH}/v1/public/workspaces/${this.dtouchWorkspace}/booking-activities/activities`
         axios.get(url)
            .then((response) => {
               this.activities = response.data.map(item => {
                  return {
                     ID: item.ID,
                     Name: this.parseJSON(item.Name),
                     Image: item.Image,
                     Source: item.Source,
                  }
               })
               console.log('jhm', response)
            })
            .catch((error) => {
               console.log(error)
            })
            .then(() => {
               this.loading = false
            })
      },*/
   },
}
</script>

